'use strict';

const helpers = {
    isMobileDevice : require('./isMobileDevice'),
    isTabletDevice : require('./isTabletDevice'),
    isTouchDevice : require('./isTouchDevice'),
    isSmallView : require('./isSmallView'),
    isTabletView : require('./isTabletView'),
    isTabletPortraitView : require('./isTabletPortraitView'),
    isDesktopView : require('./isDesktopView'),
    isDesktopOrTabletLandscapeView : require('./isDesktopOrTabletLandscapeView'),
    isBot : require('./isBot'),
    disableScroll: require('./scroll').disableScroll,
    enableScroll : require('./scroll').enableScroll,
    disableScrollEventsOnEl: require('./scroll').disableScrollEventsOnEl,
    enableScrollEventsOnEl: require('./scroll').enableScrollEventsOnEl,
    cookiesAccepted : require('./cookiesAccepted'),
    setViewportHeight : require('./setViewportHeight'),
    isInViewport: require('./isInViewport'),
    isAboveViewport: require('./isAboveViewport'),
    scrollSmooth : require('./scroll').smoothScroll,
    createSocialShareLink : require('./createSocialShareLink'),
    equalHeight : require('./equalHeight'),
    isKeyCodeNumber: require('./isKeyCodeNumber'),
    isRetina: require('./isRetina'),
    prepareDeferedImages: require('./prepareDeferedImages'),
    debounce: require('./debounce')
};

module.exports = helpers;
